import { alpha, Box, Slider, useTheme } from '@mui/material';

interface TradeSliderProps {
  value: number;
  onChange: (value: number) => void;
}

export function TradeSlider({ value, onChange }: TradeSliderProps) {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <Box sx={{ px: { xs: '12px', sm: '24px' }, mb: { xs: 1.5, sm: 0.8 } }}>
      <Slider
        value={value}
        max={1000}
        onChange={(_, newValue) => onChange(newValue as number)}
        sx={{
          color: 'primary.main',
          height: 10,
          '& .MuiSlider-track': {
            border: 'none',
          },
          '& .MuiSlider-thumb': {
            height: 28,
            width: 28,
            backgroundColor: '#FFFFFF',
            border: '4px solid',
            borderColor: 'primary.main',
            boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
            '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
              boxShadow: `0 0 0 8px ${alpha(theme.palette.primary.main, 0.16)}`,
            },
            '&:before': {
              display: 'none',
            },
          },
          '& .MuiSlider-rail': {
            opacity: 1,
            backgroundColor: isDark ? alpha(theme.palette.text.primary, 0.12) : 'divider',
          },
        }}
      />
    </Box>
  );
}
